var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _g2, _path9, _path10, _g3, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 137,
    viewBox: "0 0 166 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.0935 105.582C112.925 105.582 135.489 83.0258 135.489 55.1036C135.489 27.1814 112.826 4.625 85.0935 4.625C57.2618 4.625 34.6982 27.1814 34.6982 55.1036C34.6982 83.0258 57.2618 105.582 85.0935 105.582Z",
    fill: "#F6EAF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.208 22.0153C134.459 22.0153 136.284 20.1913 136.284 17.9412C136.284 15.6912 134.459 13.8672 132.208 13.8672C129.957 13.8672 128.133 15.6912 128.133 17.9412C128.133 20.1913 129.957 22.0153 132.208 22.0153Z",
    fill: "#F3E7F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.172 6.11144C139.709 6.11144 140.955 4.86577 140.955 3.32916C140.955 1.79255 139.709 0.546875 138.172 0.546875C136.635 0.546875 135.389 1.79255 135.389 3.32916C135.389 4.86577 136.635 6.11144 138.172 6.11144Z",
    fill: "#F3E7F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3818 21.9161C38.9189 21.9161 40.165 20.6705 40.165 19.1338C40.165 17.5972 38.9189 16.3516 37.3818 16.3516C35.8447 16.3516 34.5986 17.5972 34.5986 19.1338C34.5986 20.6705 35.8447 21.9161 37.3818 21.9161Z",
    fill: "#F3E7F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3846 75.5686C23.2392 75.5686 25.5533 73.2552 25.5533 70.4015C25.5533 67.5478 23.2392 65.2344 20.3846 65.2344C17.5299 65.2344 15.2158 67.5478 15.2158 70.4015C15.2158 73.2552 17.5299 75.5686 20.3846 75.5686Z",
    fill: "#F3E7F6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0289 77.5942L83.2873 77.6327C82.939 77.6404 82.6065 77.2845 82.6466 76.835C82.6867 76.3854 82.9698 75.9945 83.3181 75.9868L85.0597 75.9484C85.408 75.9407 85.7405 76.2966 85.7004 76.7461C85.6361 77.2817 85.3772 77.5865 85.0289 77.5942Z",
    fill: "#D9CEE2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8105_226699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.8527 31.2173L98.6951 75.3088C99.3907 76.8363 98.7183 78.6045 97.1644 79.3121L53.0975 99.4843C51.5435 100.192 49.7638 99.5499 49.0682 98.0225L22.9756 40.9613C22.28 39.4339 22.9524 37.6657 24.5064 36.958L56.3981 22.4018L77.8527 31.2173Z",
    fill: "url(#paint0_linear_8105_226699)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4593 50.5575C45.2648 53.6024 43.506 60.3439 46.5509 65.5384C49.5959 70.733 56.3373 72.4918 61.5319 69.4468C66.7264 66.4019 68.4852 59.6605 65.4403 54.4659C62.3953 49.2713 55.6539 47.5125 50.4593 50.5575ZM63.4861 61.9564L54.0414 67.4926L52.9341 65.6037L62.3788 60.0674L63.4861 61.9564ZM53.325 64.1056L51.6641 61.2722L53.553 60.1649L55.2139 62.9983L53.325 64.1056ZM56.1584 62.4447L54.4975 59.6113L56.3864 58.5041L58.0473 61.3375L56.1584 62.4447ZM58.9918 60.7838L57.3309 57.9504L59.2198 56.8432L60.8807 59.6766L58.9918 60.7838ZM59.6107 55.3451L50.166 60.8814L49.3356 59.4647L52.6738 54.3354L58.7802 53.9284L59.6107 55.3451Z",
    fill: "#E5D5EA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7812 23.0156L61.1645 34.6951C61.9491 36.3004 64.097 36.957 65.8305 36.1011L77.1925 30.8552",
    fill: "#E5D5EA"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_8105_226699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.98 33.9045L113.767 83.7806C113.703 85.4983 112.362 86.9189 110.724 86.9938L64.2411 89.2159C62.6036 89.2907 61.3563 87.9973 61.421 86.2796L63.7453 22.0706C63.81 20.353 65.1509 18.9323 66.7885 18.8575L100.41 17.2898L114.98 33.9045Z",
    fill: "url(#paint1_linear_8105_226699)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.13 40.0555C79.1092 39.982 74.123 44.848 74.0495 50.8688C73.976 56.8895 78.8419 61.8758 84.8627 61.9493C90.8835 62.0228 95.8697 57.1568 95.9432 51.1361C96.0167 45.1153 91.1508 40.129 85.13 40.0555ZM90.403 56.5427L79.4561 56.409L79.4828 54.2196L90.4297 54.3533L90.403 56.5427ZM80.5909 53.1383L80.631 49.8543L82.8203 49.881L82.7802 53.1651L80.5909 53.1383ZM83.8749 53.1784L83.915 49.8944L86.1044 49.9211L86.0643 53.2051L83.8749 53.1784ZM87.159 53.2185L87.1991 49.9344L89.3885 49.9612L89.3484 53.2452L87.159 53.2185ZM90.4965 48.8799L79.5496 48.7462L79.5697 47.1042L85.0765 44.4343L90.5166 47.2378L90.4965 48.8799Z",
    fill: "#E5D5EA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5034 18.6484L99.3164 32.2778C99.3293 34.1705 100.916 35.7368 102.771 35.6609L114.781 35.5147",
    fill: "#E5D5EA"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_8105_226699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.949 55.438L122.6 102.021C121.888 103.592 120.07 104.36 118.676 103.674L78.0062 85.5429C76.5879 84.9424 76.0416 83.0817 76.753 81.5106L104.833 21.9591C105.544 20.3881 107.363 19.6198 108.756 20.3059L138.287 33.4981L143.949 55.438Z",
    fill: "url(#paint2_linear_8105_226699)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M138.241 35.3047L132.382 47.8899C131.537 49.673 132.314 51.7563 133.977 52.5177L144.434 57.2018",
    fill: "#E5D5EA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M116.561 56.0484C111.088 53.5382 104.557 55.9623 102.046 61.4353C99.5361 66.9084 101.96 73.4401 107.433 75.9503C112.906 78.4606 119.438 76.0364 121.948 70.5634C124.458 65.0904 122.034 58.5586 116.561 56.0484ZM114.691 73.2569L104.74 68.6928L105.653 66.7026L115.604 71.2667L114.691 73.2569ZM107.104 66.164L108.473 63.1787L110.463 64.0915L109.094 67.0768L107.104 66.164ZM110.089 67.5332L111.459 64.5479L113.449 65.4607L112.08 68.446L110.089 67.5332ZM113.075 68.9024L114.444 65.9171L116.434 66.8299L115.065 69.8152L113.075 68.9024ZM117.886 66.2912L107.935 61.7272L108.619 60.2345L114.736 60.0288L118.57 64.7986L117.886 66.2912Z",
    fill: "#E5D5EA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8105_226699",
    x: 0.70166,
    y: 11.3984,
    width: 120.267,
    height: 121.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8105_226699"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8105_226699",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_8105_226699",
    x: 39.4185,
    y: 6.28906,
    width: 97.562,
    height: 115.93,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8105_226699"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8105_226699",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_8105_226699",
    x: 54.4419,
    y: 9.05469,
    width: 111.507,
    height: 127.875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8105_226699"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8105_226699",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8105_226699",
    x1: 54.5917,
    y1: 20.9477,
    x2: 68.1112,
    y2: 97.7727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F3ECF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8105_226699",
    x1: 99.4916,
    y1: 15.2149,
    x2: 81.1256,
    y2: 94.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F3ECF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8105_226699",
    x1: 123.953,
    y1: 21.8605,
    x2: 105.59,
    y2: 101.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F3ECF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBank);
export default __webpack_public_path__ + "static/media/empty-bank.a26dd899fb7189a9743ff347e50445ce.svg";
export { ForwardRef as ReactComponent };